import { useHasAnyFavouriteTemplates } from "src/store/favouriteTemplates/hooks/useSelectors";

const NAV_CONTAINER_LEFT_MARGIN = 110;
const NAV_CONTAINER_RIGHT_MARGIN = 300;
export const ARROWS_WIDTH = 48;

// eslint-disable-next-line import/prefer-default-export
export const getModulesWidths = (element: HTMLDivElement): number[] =>
  // remove left and right arrows as childrens
  Object.values(element.children).map(
    (children) => children.getBoundingClientRect().width
  );

export const useModulesUpdatedWithFavIfHas = (
  moduleIds: number[]
): number[] => {
  const hasFavouriteTemplates = useHasAnyFavouriteTemplates();

  if (hasFavouriteTemplates) return [-1, ...moduleIds];

  return moduleIds;
};

const getElementWidthByItsId = (elementId: string): number => {
  const element = document.getElementById(elementId);

  if (!element) return 0;

  return element.offsetWidth;
};

const getNavModulesLeftMargin = (): number => {
  const leftNavContainerWidth = getElementWidthByItsId("flowio-logo-container");
  return Math.max(NAV_CONTAINER_LEFT_MARGIN, leftNavContainerWidth);
};

const getNavModulesRightMargin = (): number => {
  const rightNavContainerWidth = getElementWidthByItsId("nav-user-section");
  return Math.max(NAV_CONTAINER_RIGHT_MARGIN, rightNavContainerWidth);
};

const getNavArrowsWidth = (): number => ARROWS_WIDTH;

export const getModulesContainerWidth = (navWidth: number): number => {
  const leftMargin = getNavModulesLeftMargin();
  const rightMargin = getNavModulesRightMargin();
  const arrowsMargin = getNavArrowsWidth();

  return navWidth - leftMargin - rightMargin - arrowsMargin;
};
